import { useTranslations } from "next-intl";
import { ScanToOrderCartItem } from "./scanToOrderCartItem/scanToOrderCartItem";
import { RestaurantCartValue } from "@/models/cart/types";

export interface AlreadySentToKitchenSectionProps {
  items: RestaurantCartValue[];
  onRequestClose: () => void;
}

export const AlreadySentToKitchenSection = ({
  items,
  onRequestClose,
}: AlreadySentToKitchenSectionProps) => {
  const t = useTranslations("AlreadySentToKitchenSection");
  return (
    <div className="pt-12 mx-4">
      <p className="text-[15px] text-[#727272] font-medium">{t("header")}</p>
      {items?.map((item: RestaurantCartValue, index: number) => (
        <ScanToOrderCartItem
          key={index}
          index={index}
          item={item}
          onRequestClose={onRequestClose}
          isAlreadySentToKitchen={true}
        />
      ))}
    </div>
  );
};
